export type AddOnProviderType = "Telco" | "PhoneInsurance" | "Unknown";

export const isTelcoProviderType = (
	providerType: AddOnProviderType
): boolean => {
	return providerType === "Telco";
};

export const isPhoneInsuranceProviderType = (
	providerType: AddOnProviderType
): boolean => {
	return providerType === "PhoneInsurance";
};
